import { render, staticRenderFns } from "./batchCreate.vue?vue&type=template&id=4d694c9a&scoped=true&lang=html&"
import script from "./batchCreate.vue?vue&type=script&lang=js&"
export * from "./batchCreate.vue?vue&type=script&lang=js&"
import style0 from "./batchCreate.vue?vue&type=style&index=0&id=4d694c9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d694c9a",
  null
  
)

export default component.exports